import { useCurrentCustomerQuery } from "~/queries/finance/customers";

const _useShippingLocation = () => {
  const storedShippingLocation = useStorageSafely({
    type: "localStorage",
    key: "shippingLocation",
    defaultValue: "",
  });

  const { data: customer } = useCurrentCustomerQuery();

  const customerDefaultShippingAddress = computed(() =>
    customer.value?.addresses.find((a) => a.isShippingAddress),
  );

  const shippingLocation = computed(() => {
    if (customerDefaultShippingAddress.value)
      return customerDefaultShippingAddress.value.countryCode;

    return storedShippingLocation.value.length
      ? storedShippingLocation.value
      : getEstimatedUserCountry();
  });

  return {
    shippingLocation,
    setShippingLocation: (countryCode: string) => {
      storedShippingLocation.value = countryCode;
    },
  };
};

export default createSharedComposable(_useShippingLocation);
